/** Placeholder shop signs until photo facades arrive. Made-up names in the Accra style. */
export const SHOP_SIGNS: readonly { text: string; bg: string; fg: string }[] = [
  { text: 'JAUNTY BAGS & SHOES', bg: '#1d3557', fg: '#f1faee' },
  { text: 'DUKUS BAKERY', bg: '#e63946', fg: '#ffffff' },
  { text: 'myschoolgh.com', bg: '#f4a261', fg: '#1b1b1b' },
  { text: 'JAUNTY BAGS & SHOES', bg: '#2a9d8f', fg: '#ffffff' },
  { text: 'govsitemonitor.com', bg: '#fcbf49', fg: '#3d0c02' },
  { text: 'DUKUS BAKERY', bg: '#264653', fg: '#e9c46a' },
  { text: 'myschoolgh.com', bg: '#7b2cbf', fg: '#ffffff' },
  { text: 'JAUNTY BAGS & SHOES', bg: '#ffd60a', fg: '#1b1b1b' },
  { text: 'DUKUS BAKERY', bg: '#ff70a6', fg: '#1b1b1b' },
  { text: 'myschoolgh.com', bg: '#3a5a40', fg: '#fefae0' },
  { text: 'JESUS SAVES ELECTRICALS', bg: '#003049', fg: '#fcbf49' },
  { text: 'DUKUS BAKERY', bg: '#dda15e', fg: '#283618' },
];
